export default __webpack_public_path__ + "static/media/D0010_6_Rights_National_long.1702558500000.b0ebb368.jpg";